export default __webpack_public_path__ + "static/media/termsBgDec2.5526175f.png";